import { css } from '@emotion/react'

export const detailsBlock = css`
  align-self: flex-start;
  width: 244px;
`
